export default __webpack_public_path__ + "static/media/Acolyte's Helm of the Abyss.f8dd4d28.jpg";